import { Wordmark } from '../../components/Wordmark';
import { SiteFooter } from '../../components/SiteFooter';
import { HeroSwoosh } from '../../components/HeroSwoosh';
import { LoginForm } from './LoginForm';
import { AboutJp } from './AboutJp';

type Props = {
  accent: string;
};

export function LoginSplit({ accent }: Props) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'minmax(460px, 1fr) 1fr',
        minHeight: '100vh',
        background: 'var(--cream)',
      }}
    >
      <div
        style={{
          position: 'relative',
          padding: '36px 56px 28px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          gap: 40,
          overflowY: 'auto',
        }}
      >
        <Wordmark size={18} />
        <div style={{ maxWidth: 420, position: 'relative' }}>
          <LoginForm accent={accent} />
        </div>
        <SiteFooter version="v 0.1 · build 26.05" />
      </div>
      <div style={{ position: 'relative', overflow: 'hidden' }}>
        <div className="scene" />
        <div className="horizon" />
        <HeroSwoosh />
        <div
          style={{
            position: 'absolute',
            left: 48,
            right: 48,
            bottom: 48,
            color: '#fff',
          }}
        >
          <AboutJp />
        </div>
      </div>
    </div>
  );
}
